import actions from './reportsActions'
import mutations from './reportsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}
